// MIT License - Copyright (c) 2026 Doug McNall - See .kiro/steering/general/development-standards.md for full license

import React from 'react';

/**
 * Reusable ship icon component - simplified starship design
 * @param {number} size - Width/height in pixels (default: 40)
 * @param {number} rotation - Rotation angle in degrees (default: 0)
 * @param {string} color - Primary color (default: #00ffff)
 * @param {boolean} animated - Enable engine glow animation (default: true)
 * @param {object} style - Additional inline styles
 */
const ShipIcon = ({ 
  size = 40, 
  rotation = 0, 
  color = '#00ffff',
  animated = true,
  style = {}
}) => {
  const fillColor = `rgba(${parseInt(color.slice(1, 3), 16)}, ${parseInt(color.slice(3, 5), 16)}, ${parseInt(color.slice(5, 7), 16)}, 0.3)`;
  
  return (
    <svg 
      width={size} 
      height={size} 
      viewBox="0 0 40 40" 
      style={{ 
        transform: `rotate(${rotation}deg)`,
        filter: `drop-shadow(0 0 5px ${color})`,
        ...style
      }}
    >
      {/* Saucer section */}
      <ellipse cx="20" cy="15" rx="12" ry="6" fill={fillColor} stroke={color} strokeWidth="1.5"/>
      
      {/* Neck */}
      <rect x="18" y="18" width="4" height="6" fill={fillColor} stroke={color} strokeWidth="1"/>
      
      {/* Engineering hull */}
      <ellipse cx="20" cy="28" rx="6" ry="8" fill={fillColor} stroke={color} strokeWidth="1.5"/>
      
      {/* Left nacelle */}
      <rect x="8" y="25" width="4" height="10" rx="2" fill={fillColor} stroke={color} strokeWidth="1"/>
      
      {/* Right nacelle */}
      <rect x="28" y="25" width="4" height="10" rx="2" fill={fillColor} stroke={color} strokeWidth="1"/>
      
      {/* Left engine glow */}
      <ellipse cx="10" cy="36" rx="2" ry="3" fill={color} opacity="0.8">
        {animated && <animate attributeName="opacity" values="0.5;1;0.5" dur="1s" repeatCount="indefinite"/>}
      </ellipse>
      
      {/* Right engine glow */}
      <ellipse cx="30" cy="36" rx="2" ry="3" fill={color} opacity="0.8">
        {animated && <animate attributeName="opacity" values="0.5;1;0.5" dur="1s" begin="0.5s" repeatCount="indefinite"/>}
      </ellipse>
    </svg>
  );
};

export default ShipIcon;
